module.exports = __webpack_public_path__ + "1a0498ff9195b6540e102c03886b02f4.jpg";